import { createContext } from "react";

// hold the context for the footer height value:
const LayoutHeightContext = createContext({
  navbarHeight: null,
  footerHeight: null,
});

export default LayoutHeightContext;
